import { store } from "@betacrew/jars-flux";
import { addNotifications } from "../toaster/ToasterPortalSlice";
import { SSO_INTEGRATIONS_STATES } from "./constants";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setRedirectTo, setSsoIntegrationsLoaderState } from "./SSOIntegrationsSlice";
import SignInDataService from "../../../services/SignInDataService";

export const { ssoIntegrationSignIn } = {
    ssoIntegrationSignIn: (payload) => {
        return {
            type: "SSO_INTEGRATION/SIGNIN",
            payload: payload
        }
    },
}

function* ssoIntegrationSignInAsync(action) {
    try {
        yield put(setSsoIntegrationsLoaderState({ state: SSO_INTEGRATIONS_STATES.SSO_INTEGRATION_LOADING }));
        const {data} = action.payload;
        const response = yield SignInDataService.ssoIntegrationSignIn(data);

        if(response?.data?.Status === 1){
            if(response?.data?.Data){
                yield put(setRedirectTo(response?.data?.Data))
            }
        }else{
            yield put(addNotifications({heading: "Failed to sign in", message: response?.data?.Message}))
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to sign in", message: "Please try again or contact support" }));
    } finally {
        yield put(setSsoIntegrationsLoaderState({ state: SSO_INTEGRATIONS_STATES.SSO_INTEGRATION_READY}));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(ssoIntegrationSignIn().type, ssoIntegrationSignInAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);